import { CheckDouble, ThumbsDown, ThumbsUp } from '@factorialco/f0-react/icons/app'
import { AttendanceCustomPeriodEmployeeItemFragment } from 'generated/resources/graphql'
import { AttendanceSidepanelCompensationBlockFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import type { TabId } from './types'

interface PrimaryAction {
  label: string
  icon: typeof ThumbsUp | typeof ThumbsDown
  onClick: () => void
}

interface UsePrimaryActionParams {
  employee: AttendanceCustomPeriodEmployeeItemFragment
  approvePeriod: () => void
  disapprovePeriod: () => void
  activeTab: TabId
  selectedCompensationBlocks: AttendanceSidepanelCompensationBlockFragment[]
}

export const usePrimaryAction = ({
  employee,
  approvePeriod,
  disapprovePeriod,
  activeTab,
  selectedCompensationBlocks,
}: UsePrimaryActionParams): PrimaryAction | undefined => {
  if (!employee._policies?.approveTimesheet.can) return undefined

  const isCompensationTab = activeTab === 'compensation'
  const hasSelectedCompensationBlocks = selectedCompensationBlocks.length > 0

  if (isCompensationTab && !hasSelectedCompensationBlocks) return undefined
  if (isCompensationTab && hasSelectedCompensationBlocks) {
    return {
      label: i18n.t(
        'time_tracking.table_collection.employee_summary.actions.approve_and_compensate'
      ),
      icon: CheckDouble,
      onClick: approvePeriod,
    }
  }

  if (employee.reviewStatus === 'pending') {
    return {
      label: i18n.t('time_tracking.table_collection.employee_summary.actions.approve'),
      icon: ThumbsUp,
      onClick: approvePeriod,
    }
  }
  if (employee.reviewStatus === 'approved') {
    return {
      label: i18n.t('time_tracking.table_collection.employee_summary.actions.disapprove'),
      icon: ThumbsDown,
      onClick: disapprovePeriod,
    }
  }
  return undefined
}
